// src/pages/documents/RulesFI.js
          //this will be painful to update
import React from 'react';

const RulesFI = () => {
  return (
    <div className="page rules-page">
      <section className="page-header">
        <div className="container">
          <h1>Official rules in Finnish</h1>
          <p>Below are the official rules of Integralis in Finnish</p>
        </div>
      </section>

      <section className="content-section">
        <div className="container">

          <div className="rule-card">
            <h3>Yhdistyksen säännöt </h3>
            <p>
              <h4> 1. Nimi ja kotipaikka </h4>
Yhdistyksen nimi on Integralis ry ja sen kotikunta on Helsinki. Yhdistyksen virallinen kieli on
suomi. Kokouksissa käytetään kuitenkin pääasiallisesti englantia ja kaikki yhdistyksen
dokumentit tulee olla saatavilla englanniksi.

              <h4>2. Tarkoitus ja toimintamuodot</h4>
Yhdistyksen tarkoitus on edistää Bachelor's programme in Science - linjan opiskelijoiden, sekä
kansainvälisten ja vaihto-opiskelijoiden hyvinvointia. Näihin ryhmiin viitataan dokumentissa
kohderyhmänä. Tarkoituksen toteuttamiseksi yhdistys toimii seuraavien toimintamuotojen
mukaisesti:
<ul>
  <li>valvoo kohderyhmän opiskelijoiden taloudellista, laillista sekä sosiaalista etua.</li>
  <li>järjestää vapaa-ajan tapahtumia ja toimintaa kohderyhmälle.</li>
  <li>auttaa kohderyhmän ensimmäisen vuoden opiskelijoiden ohjaamisessa.</li>
  <li>tekee yhteistyötä muiden järjestöjen kanssa.</li>
  <li>avustaa kohderyhmää opintoihin liittyvissä asioissa.</li>
</ul>

Yhdistyksen toiminnan tukemiseksi voidaan järjestää rahankeräyksiä, arpajaisia tai lipunmyyntiä
tapahtumiin. Yhdistys voi myös ottaa vastaan sponsoreita, lahjoituksia ja testamentteja ja
omistaa kiinteää omaisuutta. 

              <h4>3. Integralis ry:n osallistuminen poliittisiin tapahtumiin</h4>
Integralis ry voi osallistua selkeästi poliittisiin tapahtumiin ja tilaisuuksiin Suomen lain sekä
HYY:n asettamien rajojen ja määräysten sisällä. Integralis on puoluepoliittisesti sitoutumaton
järjestö.

<h4>4. Jäsenet</h4>
Yhdistyksen hallitus voi hyväksyä Helsingin yliopiston matemaattis- luonnontieteellisen
tiedekunnan opiskelijoita varsinaisiksi jäseniksi.
Ulkojäseniksi voidaan hyväksyä opiskelijoita Helsingin yliopiston muista tiedekunnista tai
Helsingin yliopiston ulkopuolisia henkilöitä.
Hallitus voi ottaa käyttöön mekanismeja uusien jäsenten hyväksymiseksi, kuten elektronisia
jäsenrekisterejä.
Kaikilla yhdistyksen varsinaisilla jäsenillä on puhe- ja äänioikeus yhdistyksen kokouksissa.
Yhdistyksen ulkojäsenillä on puheoikeus yhdistyksen kokouksissa.<br></br>
Yhdistyksellä on oikeus periä jäseniltään lukuvuosittaista jäsenmaksua, jonka suuruudesta
päätetään yhdistyksen varsinaisessa kokouksessa. Jäsenmaksun suuruus voi olla eri varsinaisilleja ulkojäsenille. Jäsenyys on mahdollista ostaa useammaksi lukuvuodeksi. Usean kauden
kerralla maksaminen voi maksaa vuositasolla suhteellisesti eri määrän kuin yhden kauden
maksaminen. Jäsenmaksukausi alkaa 1.8 ja loppuu 31.7.<br></br>
Hallituksen kokous voi päättää jäsenen erottamisesta. Erotettava jäsen on kutsuttava
kokoukseen ja hänelle on annettava mahdollisuus puolustaa itseään. Jäsenen erottaminen
vaatii 2/3 äänistä. Mikäli yhdistyksen jäsen haluaa erota, tulee hänen ilmoittaa asiasta
hallitukselle. Jäsen katsotaan eronneeksi, jos hän jättää yhden kauden jäsenmaksun
maksamatta.

<h4>5. Hallitus</h4>
Yhdistyksen hallitus koostuu puheenjohtajasta, varapuheenjohtajasta, sihteeristä ja
taloudenhoitajasta, sekä vähintään yhdestä ja enintään kahdeksasta muusta hallituksen
jäsenestä, joiden on oltava yhdistyksen varsinaisia jäseniä. Yhdistyksen puheenjohtajan sekä
varapuheenjohtajan on oltava Helsingin yliopiston Bachelor's programme in Science -linjan
nykyinen tai entinen opiskelija. Hallituksen toimintakausi ja yhdistyksen tilikausi on
kalenterivuosi. Hallituksen jäsen voi halutessaan erota tehtävästään. Järjestyksen kokous on
kutsuttava koolle, jos eron seurauksena hallituksen toiminta keskeytyisi.
Hallituksen tehtävänä on:
<ul>
  <li>hoitaa lain, sääntöjen, ohjesääntöjen ja yhdistyksen kokousten mukaisesti yhdistyksen asioita.</li>
  <li>valmistella luonnokset vuosittaisesta talousarviosta, toimintakertomuksesta, tilinpäätöksestä
sekä toimintasuunnitelmasta.</li>
  <li>ylläpitää jäsenluetteloa.</li>
  <li>valvoa yhdistyksen taloutta.</li>
</ul>
Hallituksen kokoukset kutsuu kokoon hallituksen puheenjohtaja tai varapuheenjohtaja.
Hallituksen kokous on päätösvaltainen, jos paikalla on vähintään puolet hallituksen jäsenistä
mukaan lukien puheenjohtaja tai varapuheenjohtaja.

<h4>6. Nimenkirjoittajat</h4>
Yhdistyksen nimen kirjoittaa hallituksen puheenjohtaja yksin tai hallituksen varapuheenjohtaja
yksin tai taloudenhoitaja yksin tai kaksi hallituksen jäsentä yhdessä.

<h4>7. Yhdistyksen kokoukset</h4>
Kokous tulee kutsua vähintään viikkoa ennen kokousta jäsenille lähetettävällä sähköpostilla.
Yhdistyksen kokoukset kutsuu kokoon hallitus.
Yhdistys pitää joka vuosi kaksi varsinaista kokousta. Alkuvuoden kokous pidetään helmi- tai
maaliskuussa. Kokouksessa vahvistetaan tilinpäätös, talousarvio sekä toimintakertomus ja
päätetään edellisen hallituksen vastuuvapaudesta ja jäsenmaksuista.<br></br>
Loppuvuoden kokouksessa valitaan hallitus, ja yksi tai kaksi toiminnantarkastajaa, ja
vahvistetaan seuraavan vuoden toimintasuunnitelma ja talousarvio. Kokous pidetään marrastai joulukuussa.
Ylimääräisiä kokouksia voidaan pitää, jos vähintään 1/10 yhdistyksen äänioikeutetuista jäsenistä
sitä vaatii tai jos hallitus pitää sitä aiheellisena.
Yhdistyksen kokous on päätösvaltainen, jos se on kutsuttu kokoon sääntöjen mukaisesti.

<h4>8. Järjestäytymiskokous</h4>
Uuden hallituksen on pidettävä järjestäytymiskokous ennen seuraavan vuoden tammikuun 31.
päivää uuden hallituksen valitsemisen jälkeen.
Järjestäytymiskokouksen kutsuu koolle uuden hallituksen puheenjohtaja tai varapuheenjohtaja.
Kokous on päätösvaltainen, jos paikalla on vähintään puolet uuden hallituksen jäsenistä
mukaan lukien puheenjohtaja tai varapuheenjohtaja.<br></br>

Jos järjestäytymiskokous pidetään ennen tammikuun 1. päivää, se on lainvoimainen, mutta sillä
on päätösvaltaa vain järjestön virkailijoiden valinnassa, tilien ja käyttäjien siirrossa vanhalta
hallitukselta uudelle hallitukselle sekä seuraavan vuoden jäsenmaksun suuruusehdotuksen
laatimisessa.

<h4>9. Vaali- ja äänestyskäytännöt</h4>
Äänestys on pidettävä suljettuna lippuäänestyksenä, jos yhdistyksen jäsen sitä ehdottaa.
Henkilövaalit pidetään aina suljettuina lippuäänestyksinä siirtoäänivaalitapaa noudattaen.
Siirtoäänivaalitavan tulee olla avoin ja selkeä kaikille osallistuville yhdistyksen jäsenille.
Yhdistyksen kokouksissa tasatilanteissa ratkaisee arpa. Hallituksen kokouksissa puheenjohtajan
ääni ratkaisee tasatilanteissa. Jos puheenjohtaja ei ole paikalla, varapuheenjohtajan ääni
ratkaisee tasatilanteen.

<h4>10. Sääntöjen muuttaminen</h4>
Yhdistyksen sääntöjä voidaan muuttaa yhdistyksen varsinaisessa kokouksessa, jos 2/3 äänistä
puoltaa sääntöjen muuttamista. Kokouskutsussa on mainittava sääntöjen muuttamisesta.

<h4>11. Yhdistyksen purkaminen</h4>
Yhdistys voidaan purkaa kahdessa varsinaisessa kokouksessa. Yhdistys voidaan purkaa, jos 4/5
äänistä puoltaa purkamista. Kokouskutsussa on mainittava yhdistyksen purkamisesta.

<h4>12. Yhdistyksen varojen käyttö lakkautuksen jälkeen</h4>
Yhdistyksen varat lahjoitetaan ensisijaisesti Limes ry:lle. Jos kyseistä järjestöä ei ole olemassa,
lahjoituskohde päätetään kokouksessa, jossa yhdistys puretaan. Yhdistyksen varat on
lahjoitettava opiskelijajärjestölle, joka toimii Helsingin yliopiston matemaattis-luonnontieteellisessä tiedekunnassa.
            </p>
                          
          </div>

        </div>
      </section>
    </div>
  );
};

export default RulesFI;

